import { useAnalytics } from 'libs/utils/site/analytics';
import { CustomMapPage } from 'pages/custom/shared/CustomMapPage';
import { CompanyButtons } from 'pages/custom/shared/detail/CompanyButtons';
import { OverflowFilters } from 'pages/custom/shared/overflow/OverflowFilters';
import { S_PageStyle } from 'pages/page/PageStyle';
import { useContext, useEffect } from 'react';
import { CtxView } from 'session/ctxView';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const PERFEKT_BUILDING = {
    name: 'VUT',
    floors: [
        { name: 'Přízemí', setId: 'cf37cd37-589f-4120-a46a-42b62787c20c' },
        { name: '1. patro', setId: '2ce1cfd6-ca5c-431e-b908-e0734beb214a' }
    ]
};

export const PerFEKTPage = (props: Props): JSX.Element => {
    const ctxView = useContext(CtxView);
    const analytics = useAnalytics();

    useEffect(() => {
        Localization.setLanguage('cs');
    }, []);

    function isSetHighlighted(mapSetId: string) {
        return ctxView.visibleMapSetIds.includes(mapSetId);
    }

    const prizemi = PERFEKT_BUILDING.floors[0].setId;
    const patro = PERFEKT_BUILDING.floors[1].setId;

    function setVisibleMapSetAndHideOthers(mapSetId: string) {
        const visible = ctxView.visibleMapSetIds;
        const newVisible = visible.filter((id) => id !== prizemi && id !== patro);
        newVisible.push(mapSetId);
        ctxView.setVisibleMapSetIds(newVisible);

        analytics.track('floor_button.clicked', {
            building: 'perfekt',
            source: 'custom_buttons',
            floorId: mapSetId
        });
    }

    return (
        <S_UIAPage className={props.className}>
            <CustomMapPage
                mapId={'82b02010-1cf7-4b50-8e2c-759e60a6c308'}
                header={{
                    logo: 'https://dvtqxks0zalev.cloudfront.net/447ec135-1abf-490a-923c-89a8a6ffab92.svg',
                    link: 'https://www.perfektjobfair.cz/cs/jobfair',
                    linkText: Localization.WEBSITE
                }}
                controls={<CompanyButtons />}
                hideFloors
                mapProps={{
                    light: {
                        anchor: 'viewport',
                        color: '#ccc',
                        intensity: 0.1
                    }
                }}
                topOverflow={
                    <OverflowFilters
                        highlightedBackground="linear-gradient(88.56deg,#001E52 0%,#05317D 100%)"
                        items={[
                            {
                                iconName: 'layer-group',
                                text: PERFEKT_BUILDING.floors[0].name,
                                onClick: () => {
                                    setVisibleMapSetAndHideOthers(prizemi);
                                },
                                highlighted: isSetHighlighted(prizemi)
                            },
                            {
                                iconName: 'layer-group',
                                text: PERFEKT_BUILDING.floors[1].name,
                                onClick: () => {
                                    setVisibleMapSetAndHideOthers(patro);
                                },
                                highlighted: isSetHighlighted(patro)
                            }
                        ]}
                    />
                }
            />
        </S_UIAPage>
    );
};

const S_UIAPage = styled(S_PageStyle)`
    display: flex;
    flex-direction: column;
`;
